import { makeQuery } from 'shared/utilities';

type ResponseType = {
    value: number;
};

export const chatMessagesUnreadCountQuery = async function () {
    return await makeQuery<ResponseType>('/chat-messages/unread-count');
}
